import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PublishPlanProgressService } from '@app/services/plan-manager/publish-plan-progress.service';

@Component({
  selector: 'app-publish-plan-progress',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './publish-plan-progress.component.html',
  styleUrl: './publish-plan-progress.component.scss'
})
export class PublishPlanProgressComponent {
  constructor(public publishPlanProgressService: PublishPlanProgressService) {}
}